export default __webpack_public_path__ + "static/media/photo-editor-pic-1.29a994f5.jpg";